"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
require("./licencesAndCertificates.scss");
const LicencesAndCertificates = (props) => {
    return (react_1.default.createElement(core_1.Box, { id: 'licences', className: `v2-container-background ${props.className}` },
        react_1.default.createElement("h4", { className: 'v2-profile-block-heading' }, "Licenses & Certificates"),
        props.certificates.map((el, i) => {
            if (el.type === 'certificate') {
                return react_1.default.createElement("p", { key: i, className: 'text' },
                    react_1.default.createElement("strong", null,
                        el.type,
                        ":"),
                    react_1.default.createElement("span", null,
                        " ",
                        el.title,
                        ", #",
                        el.license_id,
                        ", ",
                        el.year));
            }
            else {
                return react_1.default.createElement("p", { key: i, className: 'text' },
                    react_1.default.createElement("strong", null,
                        el.type,
                        ":"),
                    react_1.default.createElement("span", null,
                        " #",
                        el.license_id,
                        ", ",
                        el.state,
                        ", ",
                        el.month,
                        " ",
                        el.year));
            }
        })));
};
exports.default = LicencesAndCertificates;
